<div class="d3-line-popup-container">
  <div class="dialog-header">
    <div class="header-left">
      <span class="dialog-title">{{ heading }}</span>
    </div>

    <div class="header-right">
      <button type="button" class="close-btn" aria-label="Close" (click)="close()">
        <svg width="20" height="20" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <div class="dialog-body">
    <div class="loader-overlay" *ngIf="loader">
      <app-progress-indefinite></app-progress-indefinite>
    </div>

    <div *ngIf="!loader && chartData.length === 0" class="state-message">
      {{ error_name }}
    </div>

    <!-- Kept in the DOM via [hidden] (not *ngIf) so @ViewChild('gridLineChartContainer')
         still resolves; the chart simply isn't drawn when there's no data.
         `visibility: hidden` (via [class.chart-host--pending]) keeps layout
         intact during the open animation so the SVG measures correctly, but
         the user doesn't see it render at the wrong size. -->
    <div #gridLineChartContainer
         class="chart-host"
         [class.chart-host--pending]="!chartReady"
         [hidden]="!loader && chartData.length === 0"></div>

    <!-- In-component tooltip (mirrors small-bar-chart's #d3SBarTooltip): a plain
         absolutely-positioned div inside `.dialog-body`, positioned imperatively
         in positionTooltip(). It lives in the component's own DOM rather than a
         CDK overlay, so it can never stack behind the dialog popup. -->
    <div #linesChartTooltip
         class="container chart_tooltip d3-popup-tooltip"
         [style.visibility]="tooltipVisible ? 'visible' : 'hidden'">
      <div class="row chart_tooltip_header">
        <div class="col-12 chart_tooltip_header_data mt-1 mb-1">
          <!-- `dateLabel` is pre-formatted in the component using the same
               d3.timeFormat string as the x-axis (driven by props.period
               / report_type), so the period text matches the axis. -->
          <ng-container *ngIf="mytooltipData?.[0]?.dateLabel; else periodLabel">
            {{ mytooltipData?.[0]?.dateLabel }}
          </ng-container>
          <ng-template #periodLabel>
            {{ mytooltipData?.[0]?.periodLabel }}
          </ng-template>
        </div>
      </div>

      <div class="mt-1 pb-2">
        <div class="row" *ngFor="let series of mytooltipData">
          <div class="col-12 d-flex m-auto align-items-center">
            <div>
              <div class="tooltip_outlay" [style.background]="series.colour"></div>
            </div>
            <div class="chart_tooltip_body_data ml-2">
              {{ series.label }} : {{ series.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
